import jQuery from "jquery";
import { IsEmail, IsEmailDownload } from "./formularios.js";
window.$ = window.jQuery = jQuery;

let downloads = $(".downloadsList");
let downloadsPublic = $(".downloadsList-public");
if (downloads.length > 0 || downloadsPublic.length > 0) {
    changeContentDownloads();

    $(".filtros .tagItem").on({
        mouseenter: function () {},
        mouseleave: function () {
            if (!$(this).hasClass("active")) {
            }
        },
    });

    $(".filtros .tag").on("click", function () {
        $(".tag").removeClass("active");

        $(".tag").each((i, el) => {
            const color = $(el).attr("data-color");
        });

        $(this).addClass("active");
        if ($(".tag").hasClass("active")) {
        }

        $("#pagina").val(1);
        $("#listaConteudos").empty();
        changeContentDownloads();
    });

    $("#filtroOrdemConteudo").on("change", function () {
        $("#pagina").val(1);
        $("#listaConteudos").empty();
        changeContentDownloads();
    });

    $("#btnCarregarMaisConteudos").on("click", function () {
        changeContentDownloads();
    });

    function changeContentDownloads() {
        const $tag = $(".tags > .active").data("tag");
        const $ordem = $("#filtroOrdemConteudo").val();
        let pagina = parseInt($("#pagina").val());

        $("#loadmore").show();
        $("#btnCarregarMaisConteudos").hide();
        $.ajax({
            headers: {},
            type: "GET",
            url: "/get_downloads",
            data: {
                categoria: $tag,
                orderby: $ordem,
                page: pagina ? pagina : 1,
            },
            success: function (dataReturn) {
                if (!dataReturn.hasMoreItems) {
                    $("#btnCarregarMaisConteudos").hide();
                } else {
                    $("#btnCarregarMaisConteudos").show();
                }
                if (dataReturn.total > 0) {
                    for (let i = 0; i < dataReturn.data.length; i++) {
                        let autor = "";
                        let autorImage = "";
                        let autorBio = "";
                        if (dataReturn.data[i].author) {
                            autor = dataReturn.data[i].author.name;
                            autorImage =
                                dataReturn.data[i].author.authorImageUrl;
                            autorBio = dataReturn.data[i].author.bio;
                        }
                        let image = dataReturn.data[i].downloadImageUrl;

                        if (downloads.length > 0) {
                            $("#listaConteudos").append(
                                templateContentDownloads(
                                    image,
                                    dataReturn.data[i].title,
                                    dataReturn.data[i].description,
                                    autorImage,
                                    autor,
                                    dataReturn.data[i].postDateFormatted,
                                    dataReturn.data[i].slug, 
                                    dataReturn.data[i].category.title, 
                                    dataReturn.data[i].category.color, 
                                    dataReturn.data[i].author.bio,
                                    dataReturn.data[i].downloadURL
                                )
                            );
                        } else if (downloadsPublic.length > 0) {
                            $("#listaConteudos").append(
                                templateExclusiveContentPreview(
                                    image,
                                    dataReturn.data[i].title,
                                    dataReturn.data[i].description,
                                    autorImage,
                                    autor,
                                    dataReturn.data[i].postDateFormatted,
                                    dataReturn.data[i].slug, 
                                    dataReturn.data[i].category.title,
                                    dataReturn.data[i].category.color, 
                                    dataReturn.data[i].author.bio, 
                                    dataReturn.data[i].downloadURL
                                )
                            );
                        }
                    }
                } else {
                    $("#listaConteudos").append(
                        "<p>Nenhum resultado encontrado</p>"
                    );
                }
                $("#loadmore").hide();
                $("#pagina").val(pagina + 1);
            },
            error: function (dataReturn) {
                $("#loadmore").hide();
            },
        });
    }
    function stripHtml(html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    function templateExclusiveContentPreview(
        imagem,
        titulo,
        texto,
        imagemAutor,
        autor,
        dataPost,
        link,
        categoria,
        corCategoria,
        autorBio,
        urlDownload
    ) {
        link = stripHtml(link);
        let template = `
        <div class="col-12 topicoItem">
            <div class="card-conteudo">
                <a href="${urlDownload}" class="card-link">
                    <div class="conteudo-exclusivo">
                        <p class="conteudo-exclusivo-txt">Conteúdo exclusivo</p>
                    </div>
                    <div class="card-image">
                        <img src="${imagem}" alt="${titulo}">
                    </div>
                    <div class="card-content">
                        <div class="card-meta">
                            <div class="card-date">${formatarData(
                                dataPost
                            )}</div>
                            <div class="card-source">${
                                autor || "Close-up Internacional"
                            }</div>
                        </div>
                        <h3 class="card-title">${titulo}</h3>
                        <div class="card-footer">
                            <div class="card-cta">
                                <span class="leia-mais">Leia mais</span>
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.00006 6.75732C0.447776 6.75732 6.10641e-05 7.20504 6.10352e-05 7.75732C6.10062e-05 8.30961 0.447776 8.75732 1.00006 8.75732L1.00006 7.75732L1.00006 6.75732ZM16.5731 8.46443C16.9637 8.07391 16.9637 7.44074 16.5731 7.05022L10.2092 0.686257C9.81864 0.295732 9.18548 0.295732 8.79495 0.686257C8.40443 1.07678 8.40443 1.70995 8.79495 2.10047L14.4518 7.75732L8.79495 13.4142C8.40443 13.8047 8.40443 14.4379 8.79495 14.8284C9.18548 15.2189 9.81864 15.2189 10.2092 14.8284L16.5731 8.46443ZM1.00006 7.75732L1.00006 8.75732L15.866 8.75732L15.866 7.75732L15.866 6.75732L1.00006 6.75732L1.00006 7.75732Z" fill="#82CCDD"/>
                                </svg>
                            </div>
                            <div class="card-category">
                                ${categoria}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    `;

        return template;
    }
    function formatarData(dataStr) {
        if (!dataStr) return "";

        const data = new Date(dataStr);
        if (isNaN(data)) return "";

        const dia = data.getDate().toString().padStart(2, "0");
        const mes = data
            .toLocaleDateString("pt-BR", { month: "short" })
            .replace(".", "");
        const ano = data.getFullYear().toString().slice(-2);

        return `${dia} de ${mes} ${ano}`;
    }
    function templateContentDownloads(
        imagem,
        titulo,
        texto,
        imagemAutor,
        autor,
        dataPost,
        link,
        categoria,
        corCategoria,
        autorBio,
        urlDownload
    ) {
        link = stripHtml(link);
        let template = `
        <div class="col-12 topicoItem">
            <div class="card-conteudo">
                <a href="${urlDownload}" class="card-link">
                    <div class="conteudo-exclusivo">
                        <p class="conteudo-exclusivo-txt">Conteúdo exclusivo</p>
                    </div>
                    <div class="card-image">
                        <img src="${imagem}" alt="${titulo}">
                    </div>
                    <div class="card-content">
                        <div class="card-meta">
                            <div class="card-date">${formatarData(
                                dataPost
                            )}</div>
                            <div class="card-source">${
                                autor || "Close-up Internacional"
                            }</div>
                        </div>
                        <h3 class="card-title">${titulo}</h3>
                        <div class="card-footer">
                            <div class="card-cta">
                                <span class="leia-mais">Leia mais</span>
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.00006 6.75732C0.447776 6.75732 6.10641e-05 7.20504 6.10352e-05 7.75732C6.10062e-05 8.30961 0.447776 8.75732 1.00006 8.75732L1.00006 7.75732L1.00006 6.75732ZM16.5731 8.46443C16.9637 8.07391 16.9637 7.44074 16.5731 7.05022L10.2092 0.686257C9.81864 0.295732 9.18548 0.295732 8.79495 0.686257C8.40443 1.07678 8.40443 1.70995 8.79495 2.10047L14.4518 7.75732L8.79495 13.4142C8.40443 13.8047 8.40443 14.4379 8.79495 14.8284C9.18548 15.2189 9.81864 15.2189 10.2092 14.8284L16.5731 8.46443ZM1.00006 7.75732L1.00006 8.75732L15.866 8.75732L15.866 7.75732L15.866 6.75732L1.00006 6.75732L1.00006 7.75732Z" fill="#82CCDD"/>
                                </svg>
                            </div>
                            <div class="card-category">
                                ${categoria}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    `;

        return template;
    }

    function downloadForm() {
        $("#emailDownload").on("focusout", function () {
            if (IsEmail($(this).val()) === false) {
                $(this).addClass("errorField");
            } else {
                $(this).removeClass("errorField");
            }
        });

        $("#btnEfetuaDownload").on("click", function (e) {
            e.preventDefault();

            $("#btnEfetuaDownload").html("Aguarde processando...");
            $("#btnEfetuaDownload").attr("disabled", true);

            let nome = $("#nomeDownload");
            let email = $("#emailDownload");

            let erros = 0;

            if (nome.val().length < 2) {
                nome.addClass("errorField");
                erros++;
            } else {
                nome.removeClass("errorField");
            }

            if (email.val() === "" || !IsEmail(email.val())) {
                email.addClass("errorField");
                erros++;
            } else {
                email.removeClass("errorField");
            }

            if (erros == 0) {
                $("#btnEfetuaDownload").attr("disabled", true);

                let inputData = new FormData();

                inputData.append("nome", $("#nome").val());
                inputData.append("email", $("#email").val());
                inputData.append("token", $("#_token").val());

                /*
                $.ajax({
                    type: 'POST',
                    url: "/ajax/cadastra.php",
                    processData: false,
                    contentType: false,
                    data: inputData,
                    success: function(dataReturn) {
                        console.log(dataReturn);

                        if(dataReturn.sucesso === true) {
                            */
                let arquivoGo = $("#arquivo").val();
                window.open(arquivoGo);
                $("#btnEfetuaDownload").html("Download do Arquivo");
                $("#btnEfetuaDownload").attr("disabled", false);
                $("#formDownload")[0].reset();
                $(".modalDownload").fadeOut();

                /*
                            $('.erroMessage').html('');
                            $('.erroMessage').fadeOut();
                            $("#btnEnviarContato").html("Enviar mensagem");
                            $("#btnEnviarContato").attr('disabled', false);
                            formContato[0].reset();


                        }

                        if(dataReturn.sucesso === false) {
                            $('.erroMessage').html(dataReturn.erro);
                            $('.erroMessage').fadeIn();
                            $("#btnEnviarContato").html("Enviar mensagem");
                            $("#btnEnviarContato").attr('disabled', false);
                        }

                    },
                    error: function(dataReturn) {
                        console.log('Status: '+dataReturn.status);
                        $("#btnEnviarContato").html("Enviar mensagem");
                        $("#btnEnviarContato").attr('disabled', false);
                    }
                });
                */
            } else {
                // $('.erroCadastro').fadeIn();
                // $("#btnEnviarContato").html("Enviar mensagem");
                // $("#btnEnviarContato").attr('disabled', false);
                $("#btnEfetuaDownload").html("Download do Arquivo");
                $("#btnEfetuaDownload").attr("disabled", false);
            }
        });
    }
}

$("#email").on("focusout", function () {
    if (IsEmailDownload($(this).val()) === false) {
        $(this).addClass("errorField");
        // $(".form-group-email").append(
        //     "<div class='warning-email' style='color:#FF9600'>o campo precisa ser preenchido com um e-mail valido</div>"
        // );
    } else {
        $(this).removeClass("errorField");
        $(".warning-email").remove();
    }
});

$(document).ready(function () {
    // Máscaras são aplicadas via classes CSS no formularios.js
    // Mantenha apenas eventos específicos aqui
});

let ciente = false;
$("#professionalTerms").on("change", function () {
    $(this).is(":checked") ? (ciente = true) : (ciente = false);
});

let politica = false;
$("#privacyTerms").on("change", function () {
    $(this).is(":checked") ? (politica = true) : (politica = false);
});

let coleta = false;
$("#marketingConsent").on("change", function () {
    $(this).is(":checked") ? (coleta = true) : (coleta = false);
});

// $("body").on('change', function(){
//     if(ciente == true && politica == true && coleta == true){
//         $('#btnPerfil').removeClass('disabled-btn-azul')
//     }
// });

$("#backCadastre").on("click", function () {
    $("#perfil").addClass("hidden-content");
    $("#cadastre").removeClass("hidden-content");
});

$(".backPerfil").on("click", function () {
    $("#perfilProfissional").addClass("hidden-content");
    $("#profile").val("");

    $("#perfil").removeClass("hidden-content");
});

$("#backChecklist").on("click", function () {
    $("#checklist").addClass("hidden-content");
    $("#perfilProfissional").removeClass("hidden-content");
});

$(".backPerfil").on("click", function () {
    $("#perfilEstudante").addClass("hidden-content");
    $("#perfil").removeClass("hidden-content");
});

$("#btnPerfil").on("click", function () {
    $("#cadastre").addClass("hidden-content");
    $("#perfil").removeClass("hidden-content");
});

$("#profissional").on("click", function () {
    $("#perfil").addClass("hidden-content");
    $("#profile").val("profissional");
    $("#perfilProfissional").removeClass("hidden-content");
});

$("#estudante").on("click", function () {
    $("#perfil").addClass("hidden-content");
    $("#profile").val("estudante");
    $("#perfilEstudante").removeClass("hidden-content");
});

$("#btnProfissional").on("click", function () {
    $("#perfilEstudante").addClass("hidden-content");
    $("#profile").val("profissional");
    $("#perfilProfissional").removeClass("hidden-content");
});

$("#btnEstudante").on("click", function () {
    $("#perfilProfissional").addClass("hidden-content");
    $("#profile").val("estudante");
    $("#perfilEstudante").removeClass("hidden-content");
});

$("#checklistProfissional").on("click", function () {
    $("#perfilProfissional").addClass("hidden-content");
    $("#checklist").removeClass("hidden-content");
});
$("#checklistEstudante").on("click", function () {
    $("#perfilEstudante").addClass("hidden-content");
    $("#checklist").removeClass("hidden-content");
});
